import { Box, List, Typography, paletteColors } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

import GlobeIcon from '@evaneos/b2b-ui/icons/Public';

import { DisplayDossierOverviews } from '../../../resources/dossier/types';

import { Block } from '../shared/Block';

import { NewRequestItem } from './NewRequestItem';

export const NewRequestsBlock = ({ newRequests }: { newRequests: DisplayDossierOverviews }) => {
    const { formatMessage } = useIntl();
    const hasRequests = newRequests.length > 0;

    return (
        <Block
            title={formatMessage(
                { id: 'homepage.new_request.title' },
                {
                    count: newRequests.length,
                },
            )}
        >
            {hasRequests ? (
                <List
                    data-testid="new-requests-list"
                    disablePadding
                    sx={{
                        flex: { xs: '1 1 336px', md: '1 1 0' },
                        overflowY: 'auto',
                    }}
                >
                    {newRequests.map((dossier) => (
                        <NewRequestItem key={dossier.id} dossier={dossier} />
                    ))}
                </List>
            ) : (
                <Box
                    data-testid="empty-new-requests"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: { xs: '0 0 auto', md: 1 },
                        alignItems: 'center',
                        justifyContent: 'center',
                        px: 3,
                        margin: 'auto',
                        textAlign: 'center',
                        minHeight: { xs: '200px', md: 'auto' },
                    }}
                >
                    <GlobeIcon
                        htmlColor={paletteColors.green[700]}
                        aria-hidden="true"
                        sx={{ fontSize: 32, mb: 0.5 }}
                    />
                    <Typography variant="body1" fontWeight={700}>
                        {formatMessage({ id: 'homepage.new_request.empty.title' })}
                    </Typography>
                    <Typography variant="body2" fontWeight={700} color="text.secondary">
                        {formatMessage({ id: 'homepage.new_request.empty.description' })}
                    </Typography>
                </Box>
            )}
        </Block>
    );
};
